module.exports = __webpack_public_path__ + "static/img/30011 (2).9b68553.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30011 (2).webp
// module id = wai3
// module chunks = 14